import { CubeProvider } from '@cubejs-client/react';
import { CUBE_API_URL, VIZIT_ENV } from '@vizit/constants';
import * as React from 'react';
import { createCubeApi } from '../cube-api';

interface CubeAnalyticsProviderProps {
  children: React.ReactNode;
  onSessionExpired?: (error: unknown) => void | Promise<void>;
}

function CubeAnalyticsProvider(props: CubeAnalyticsProviderProps) {
  const { children, onSessionExpired } = props;

  React.useEffect(() => {
    if (!CUBE_API_URL && VIZIT_ENV !== 'prod') {
      console.warn('VITE_CUBE_API_URL is not set, so analytics queries will fail. Only dev1 has a Cube today.');
    }
  }, []);

  const onSessionExpiredRef = React.useRef(onSessionExpired);
  onSessionExpiredRef.current = onSessionExpired;

  const cubeApi = React.useMemo(
    () =>
      createCubeApi({
        apiUrl: CUBE_API_URL,
        onSessionExpired: (error) => onSessionExpiredRef.current?.(error),
        onFreshTokenRejected: () => {
          console.error(
            `Cube rejected a freshly issued token. This is a configuration problem, not an expiry: ${CUBE_API_URL} is paired with a different vizit-api environment than the one this app talks to.`,
          );
        },
      }),
    [],
  );

  return <CubeProvider cubeApi={cubeApi}>{children}</CubeProvider>;
}

export { CubeAnalyticsProvider };
export type { CubeAnalyticsProviderProps };
